import {DialogContent, DialogTitle, TextField} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {useState} from "react";
import {Keying2Config} from "../../../../api/Keying2";
import {useAsyncAction} from "nate-react-api-helpers";
import {useReloader} from "../hardware/ReloadContext";
import {api} from "../../../../api/API";

export function AddEditDesignation(props: {
    value: Keying2Config;
    name: string;
    onClose(): void;
}) {
    // @ts-ignore
    const exist = props.value.labelsAvailable?.find(p => p.name === props.name);
    const [short, setShort] = useState<string>(exist?.name || "")
    const [title, setTitle] = useState<string>(exist?.title || "")
    const [long, setLong] = useState<string>(exist?.description || "");
    const [count, setCount] = useState<string>(exist?.keyCount?.toString() || "0")

    const reload = useReloader();
    const update = useAsyncAction(async (input) => {
        await api.keying2.update(input);
        reload.current();
        props.onClose();
    }, []);

    const submit = () => {
        const available = props.value.labelsAvailable?.slice(0) || [];
        const found = available.findIndex(l => l.name === exist?.name);
        if(found >= 0) {
            available[found] = {
                name: short,
                title: title,
                oldName: exist?.name,
                keyCount: parseInt(count || "0"),
                description: long,
            };
        } else {
            available.push({
                name: short,
                title,
                keyCount: parseInt(count || "0"),
                description: long,
            })
        }

        update.callback({
            ...props.value,
            labelsAvailable: available,
        })
    };

    return (
        <Dialog2 open onClose={props.onClose} maxWidth="sm" fullWidth onEnterPress={submit}>
            <DialogTitle>{exist ? "Edit" : "Add"} Designation</DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                <TextField style={{width: 200}} required label="Short Name" value={short} onChange={e => setShort(e.target.value)} />
                <div style={{height: 12}} />
                <TextField style={{width: 200}} required label="Title" value={title} onChange={e => setTitle(e.target.value)} />
                <div style={{height: 12}} />
                <TextField
                    fullWidth label="Long Name" required value={long} onChange={e => setLong(e.target.value)}
                />
                <div style={{height: 12}} />
                <TextField style={{width: 200}} label="Key Count" required
                           value={count}
                           onChange={e => setCount(e.target.value)} />
            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                error={update.error}
                actionName={!!exist ? "Save" : "Add"}
                onSubmit={submit}
                onCancel={props.onClose}
                onDestroy={exist ? () => update.callback({
                    ...props.value,
                    // @ts-ignore
                    labelsAvailable: props.value.labelsAvailable?.filter(l => l.name !== props.name),
                }) : undefined}
                destroyLoading={update.loading}
                destroyName="Delete"
            />
        </Dialog2>
    )
}